export default "__VITE_ASSET__$CEmZaRz__"